import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Container, Columns, Column, Button, Modal } from '@resurs/midas-react'
import { TextInput } from '../../../midasComponents'
import { getText } from '../../../internal/TextLabels'

const TransactionInvoiceModal = props => {
  const [invoiceRef, setInvoiceRef] = useState('')
  const [isValid, setIsValid] = useState(false)

  useEffect(() => {
    if (!props.show) {
      setInvoiceRef('')
      setIsValid(false)
    }
  }, [props.show])

  const handleChange = value => {
    setInvoiceRef(value)
    setIsValid(!!(value && value.trim()))
  }

  return (
    <Modal
      title={getText('transactions.transaction.invoice.heading')}
      show={props.show}
      hideClose
      actions={
        <div>
          <Button
            type="link"
            text={getText('default.cancel')}
            onClick={() => props.onClose()}
          />
          <Button
            type="normal"
            text={getText('default.perform')}
            onClick={() => props.handleSubmit(invoiceRef)}
            disabled={!isValid}
            dataCy="perform-invoice-button"
          />
        </div>
      }
    >
      <Container>
        <Columns>
          <Column col12>
            <p style={{ margin: 0 }}>
              {getText('transactions.transaction.invoice.description')}
            </p>
          </Column>
          <Column col6>
            <TextInput
              label={getText('transactions.transaction.invoice.inputLabel')}
              id="invoiceRef"
              type="text"
              onChange={e => handleChange(e.target.value)}
              value={invoiceRef}
              required={getText(
                'transactions.transaction.invoice.requiredInput',
              )}
            />
          </Column>
        </Columns>
      </Container>
    </Modal>
  )
}

TransactionInvoiceModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

TransactionInvoiceModal.defaultProps = {
  show: false,
}
export default TransactionInvoiceModal
